module.exports = __webpack_public_path__ + "img/w25-b1.e4c0b0e7.jpg";